import { envConfig } from '../../../../env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + "/cotton/admin/gameInfo/"

export function insertGameInfo(data) {
    return Post(baseUrl + "insertGameInfo", data)
}

export function deleteGameInfo(data) {
    return Post(baseUrl + "deleteGameInfo", data)
}

export function updateGameInfo(data) {
    return Post(baseUrl + "updateGameInfo", data)
}

export function queryGameInfo(data) {
    return Post(baseUrl + "queryGameInfo", data)
}